<template>
	<div>
		<h3>
			Welcome to MyLab
		</h3>
		<h4>
			You currently have no accounts and therefore have limited MyLab functionality.
		</h4>

		<label>Do you have any existing accounts with Midwest Labs?</label><br>
		<label class="radio-inline"><input type="radio" v-bind:value="false" v-model="has_accounts"> No</label>
		<label class="radio-inline"><input type="radio" v-bind:value="true" v-model="has_accounts"> Yes</label>

		<div v-if="!has_accounts">
			<div class="col-sm-12" style="font-size:18px" >
				<h3 class="text-center">Create New Account</h3>
			</div>

			<label>Will you be using MyLab for Personal use or on behalf of a Business?</label><br>
			<label class="radio-inline"><input type="radio" v-bind:value="false" v-model="business_account"> Personal</label>
			<label class="radio-inline"><input type="radio" v-bind:value="true" v-model="business_account"> Business</label>
			<hr>

			<div v-if="business_account">
				<div class="row">
					<div :class="how_heard.comment === true ? 'col-lg-6' : 'col-lg-12'">
						<div class="form-group fg-line">
							<label>How did you or your company hear about Midwest Laboratories?</label>
							<select class="form-control required" required v-model="how_heard">
								<option v-for="option in how_heard_options" :value="option"
										v-html="option.option">
								</option>
							</select>
						</div>
					</div>

					<div v-show="how_heard.comment === true" class="col-lg-6">
						<div class="form-group fg-line">
							<label for="how_heard_comment" v-if="how_heard.option == 'Other (please add comment)'">Additional Information Required</label>
							<label for="how_heard_comment" v-if="how_heard.option == 'Referral (please add comment)'">Name of Person or Company Reference</label>
							<input type="text" id="how_heard_comment" v-model="how_heard_comment" maxlength="62" class="form-control"
																												 placeholder="Please Comment">
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-lg-6">
						<div class="fg-line form-group">
							<label for="account_nm">Company Name</label>
							<input type="text" id="account_nm" v-model="company_nm" maxlength="30" class="form-control" >
						</div>
					</div>
					<div class="col-lg-6">
						<div class="fg-line form-group">
							<label for="company_website">Company Website</label>
							<input type="text" id="company_website" v-model="company_website" maxlength="100" placeholder="optional" class="form-control">
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-lg-4">
						<div class="form-group fg-line">
							<label>Analysis Industry</label>
							<span class="fg-line">
								<industry-help-me-picker
									:button_text="selectIndustryBtnText"
									@set-industry="setIndustry">
								</industry-help-me-picker>
							</span>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="form-group fg-line">
							<label>Sample Types</label>
							<multi-select-ex
								:placeholder_caption ="'Select Sample Types'"
								:caption_field = "'sample_type_nm'"
								:value_field = "'sample_type_id'"
								:option_list="sample_type_list"
								:selected_option_values="selectedSampleTypeIds"
								:limit="5"
								@save="updateSampleTypeList"
								:disabled="!industryId">
							</multi-select-ex>
						</div>
					</div>
                    <div class="col-lg-4">
                        <label>Sample Frequency</label>
                        <select class="form-control fg-line" v-model="sampleFreqId" style="text-transform: capitalize">
                            <option v-for="freq in Object.keys(sampleFreqMap)"
                                    :value="sampleFreqMap[freq]"
                                    v-html="freq.toLowerCase()"
                            ></option>
                        </select>
                    </div>
				</div><!-- /row 1 name -->
                <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>
                                <input type="checkbox" class="m-1-10" v-model="regulatory_samples">
                                Regulatory Samples
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>
                                <input type="checkbox" class="m-1-10" v-model="tax_exempt">
                                Tax Exempt
                            </label>
                            <div v-if="tax_exempt">
                                <small>
                                    Please email Tax Exempt Documentation directly to <a href="mailto:accounting@midwestlabs.com">accounting@midwestlabs.com</a>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

				<address-entry
					:copy_address="userAddress"
					copy_address_label="Use your Address"
					:usa_only="false"
					@update="updateAccountAddress">
				</address-entry>

				<app-message-list
					:form_errors="form_errors">
				</app-message-list>

				<div class="stack-footer text-center">
					<button type="button" class="btn btn-primary btn-lg" :disabled="isRegisterButtonDisabled"
										  @click="submitForm()">
						<i class="fa fa-check"></i> Register
					</button>
				</div>
			</div>
			<div v-else>
				<div class="row">
					<div class="col-lg-4">
						<div class="form-group fg-line">
							<label>Analysis Industry</label>
							<span class="fg-line">
								<industry-help-me-picker
									:button_text="selectIndustryBtnText"
									@set-industry="setIndustry">
								</industry-help-me-picker>
							</span>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="form-group fg-line">
							<label>Sample Types</label>
							<multi-select-ex
								:placeholder_caption ="'Select Sample Types'"
								:caption_field = "'sample_type_nm'"
								:value_field = "'sample_type_id'"
								:option_list="sample_type_list"
								:selected_option_values="selectedSampleTypeIds"
								:limit="5"
								@save="updateSampleTypeList"
								:disabled="!industryId">
							</multi-select-ex>
						</div>
					</div>
                    <div class="col-lg-4">
                        <label>Sample Frequency</label>
                        <select class="form-control fg-line" v-model="sampleFreqId" style="text-transform: capitalize">
                            <option v-for="freq in Object.keys(sampleFreqMap)"
                                    :value="sampleFreqMap[freq]"
                                    v-html="freq.toLowerCase()"
                            ></option>
                        </select>
                    </div>
				</div>

				<app-message-list
					:form_errors="form_errors">
				</app-message-list>

				<div class="stack-footer text-center">
					<button type="button" class="btn btn-primary btn-lg" :disabled="isRegisterButtonDisabled"
										  @click="submitForm()">
						<i class="fa fa-check"></i> Register
					</button>
				</div>
			</div>
		</div>

		<div v-else>
			<!-- row list accounts -->
			<app-message-list
				:form_messages="relatedAccountsMessage">
			</app-message-list>
			<my-account-role-list
				v-for="(userAccount,index) in user_accounts"
				:index="index"
				:key="userAccount.user_account_id"
				:account_nbr="userAccount.account_nbr"
				:account_nm="userAccount.account.account_nm"
				:city="userAccount.account.city"
				:state_cd="userAccount.account.state_cd"
				:user_account_roles="userAccount.rolesArray"
				:all_roles="all_roles"
				@unselect="unselectAccount"
				@add="addRole"
				@delete="deleteRole"
				@approve="approveRoles">
			</my-account-role-list>

			<div class="row">
				<div class="col-sm-3">
					<div class="form-group">
						<label>Account Number</label>
						<span class="fg-line">
							<input class="form-control" placeholder="Account Number" v-model="addAccountNumber" type="number">
						</span>
						<span v-if="field_error['add_account_nbr']" class="simple-error">{{ field_error['add_account_nbr'] }} </span>
						<span v-else class="help-block">Add an account to this list</span>
					</div>
				</div>
				<div class="col-sm-6">
					<button class="btn add-btn" type="button" @click="onAddAccountClick">
						<span class="fa fa-arrow-right"></span> &nbsp;Add Account
					</button>
				</div>
			</div>
			<span v-if="form_status" class="simple-status"> @{{ form_status }} </span>
		</div>
	</div>
</template>

<script>
	import {mapMutations, mapState} from 'vuex';
	import {isCountyValid} from '../address/sanitizeCounty';

	export default {
		name: "first-account-selection",
		props: [
			'all_roles',
			'field_error',
			'form_status',
			'industries',
			'related_accounts',
			'industry_sample_types',
			'how_heard_options',
            'sampleFreqMap'
		],
		data: function () {
			return {
				has_accounts: false,
				addAccountNumber: "",
				form_errors : [],

				how_heard : {},
				how_heard_comment: '',
				company_nm : "",
				company_website : "",
				industryId : "",
				selectedSampleTypeIds : [],
				regulatory_samples : false,
				tax_exempt : false,
				is_processing : false,
				address : {},
				business_account: false,
                sampleFreqId: 1
			};
		},
		computed: {
			...mapState('user', ['user_accounts', 'visible_user']),

			selectIndustryBtnText() {
				const industry = this.industries.find(industry => this.industryId === industry.industry_id);
				return industry ? industry.industry_nm : 'Select Industry*';
			},

			requiredInputsValid() {
				return this.industries.some(industry => this.industryId === industry.industry_id) &&
					this.selectedSampleTypeIds.length > 0 && (
						!this.business_account ||
						this.howHeardValue.length > 0 &&
						this.company_nm.length > 0 &&
						this.addressCountyValid
					);
			},

			addressCountyValid() {
				return isCountyValid(this.address);
			},

			isRegisterButtonDisabled() {
				return !this.requiredInputsValid || this.is_processing;
			},

			relatedAccountsMessage() {
				if (this.related_accounts.length > 0) {
					let messages = [
						"We've found the following accounts in our system with your email.  If you'd like to be given access to any of them, add their account numbers below."
					];
					let accounts = this.related_accounts.map(account => "#" + account.account_nbr + " - " + account.name);
					return messages.concat(accounts);
				}
				return [];
			},

			userAddress() {
				return {
					address1: this.visible_user.address1,
					address2: this.visible_user.address2,
					city: this.visible_user.city,
					county: this.visible_user.county,
					state_cd: this.visible_user.state_cd,
					postal_cd: this.visible_user.postal_cd,
					country_cd: this.visible_user.country_cd,
					is_residential: this.visible_user.is_residential
				};
			},

			sample_type_list() {
				return this.industry_sample_types[this.industryId];
			},

			howHeardValue() {
				if (this.how_heard.comment === true) {
					return (this.how_heard.option && this.how_heard_comment) ? (this.how_heard.option + ' - ' + this.how_heard_comment) : '';
				}
				else {
					return this.how_heard.option ? this.how_heard.option : '';
				}
			},
		},
		methods: {
			...mapMutations('user', [
				'unselectAccount',
				'deleteRole',
				'addRole',
				'approveRoles'
			]),

			onAddAccountClick() {
				this.$emit('add-account-click', this.addAccountNumber);
			},

			setIndustry(newIndustryId) {
				this.industryId = newIndustryId;
				this.selectedSampleTypeIds = [];
			},

			updateAccountAddress(address) {
				this.address = address;
			},

			updateSampleTypeList(samples) {
				this.selectedSampleTypeIds = samples;
			},

			submitForm() {
				// For some reason, disabled buttons are still clickable, so we have to double check input validity before processing
				if (this.isRegisterButtonDisabled) {
					return;
				}

				this.is_processing = true;

				// Use user info if not a business account
				let params = this.business_account ? {
					how_heard : this.howHeardValue,
					company_nm : this.company_nm,
					company_website : this.company_website,
					analysis_industry : this.industryId,
					sample_type_ids: this.selectedSampleTypeIds,
					regulatory : this.regulatory_samples,
					tax_exempt : this.tax_exempt,
					address : {
						address1 : this.address.address1,
						address2 : this.address.address2,
						city : this.address.city,
						state_cd : this.address.state_cd,
						postal_cd : this.address.postal_cd,
						county : this.address.county ? this.address.county : '', // Default to empty string as internal API requires county, but International clients don't necessarily have one
						country_cd : this.address.country_cd,
						is_residential : this.address.is_residential
					},
                    sample_freq_id : this.sampleFreqId,
				} : {
					how_heard : this.visible_user.how_heard ? this.visible_user.how_heard : 'Other',  // Default to 'Other' if not there. This shouldn't happen because it's now required upon user registration, but we'll set a default
					company_nm : this.visible_user.first_nm.toUpperCase() + " " + this.visible_user.last_nm.toUpperCase(),   // TODO What happens if these are null?
					company_website : "",
					analysis_industry : this.industryId,
					sample_type_ids: this.selectedSampleTypeIds,
					regulatory : false,
					tax_exempt : false,
					address : this.userAddress,
                    sample_freq_id : this.sampleFreqId,
				};

				// Process Data /my/account-roles/create-first-account
				this.$http.post('/my/account-roles/create-first-account', params)
					.then(() => {
						// redirect to front page, which should reload the site, now with more features because they should have an account
						window.location.href = '/home';
					})
					.catch(data => {
						// Input validation error
						if (data.status === 422) {
							this.form_errors = [
								data.body.message
							];
						} else {
							this.form_errors = [
								"There was an issue creating your account. Please try again later"
							];
						}
					})
					.finally(() => {
						this.is_processing = false;
					});
			}
		},
	    mounted() {
		    // Default to the first sample freq in the map
		    this.sampleFreqId = this.sampleFreqMap[_.first(Object.keys(this.sampleFreqMap))];
        }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// first-account-selection.vue?467b0655